import PositionDomain from "@serie3/freelancesplaceapi/Domain/Billing/Outgoing/Position";
import { useContext } from "react";
import SettingsContext from "@serie3/common/auth/SettingsContext";
import formatAmount from "../../formatAmount";

const BillSummary = ({ positionen = [] }) => {
  const { settings } = useContext(SettingsContext);
  const locale = settings?.locale;
  const fmt = (n) => formatAmount(n, locale);
  let nett = 0, tax = 0, total = 0;
  positionen.forEach((p) => {
    nett  += parseFloat(PositionDomain.calculatePositionNett(p));
    tax   += parseFloat(PositionDomain.calculatePositionTax(p));
    total += parseFloat(PositionDomain.calculatePositionGross(p));
  });

  const Row = ({ label, value, bold, accent }) => (
    <div style={{
      display: "flex", justifyContent: "space-between", alignItems: "center",
      padding: "8px 0",
      borderTop: bold ? "2px solid #e0e0e0" : "1px solid #f0f0f0",
    }}>
      <span style={{ fontSize: bold ? "0.95rem" : "0.88rem", fontWeight: bold ? 700 : 500, color: "#616161" }}>
        {label}
      </span>
      <span style={{ fontSize: bold ? "1.05rem" : "0.9rem", fontWeight: bold ? 800 : 600, color: accent || (bold ? "#212121" : "#424242") }}>
        € {value}
      </span>
    </div>
  );

  return (
    <div style={{
      background: "#fff", borderRadius: "10px",
      padding: "14px 18px", boxShadow: "0 1px 6px rgba(0,0,0,0.07)",
    }}>
      <Row label="Subtotal" value={fmt(nett)} />
      <Row label="Tax" value={fmt(tax)} />
      <Row label="Total" value={fmt(total)} bold accent="#2e7d32" />
    </div>
  );
};

export default BillSummary;
